export default class Uap {
  constructor(){
    var userAgent = navigator.userAgent;
    this._regexes = require("./regexes").regexes;
    this._parser = require("uap-ref-impl/lib/parser")(this._regexes);
    this._result = this._parser.parse(userAgent);
  }

  compact(arr){
    var tempArr = [];
    arr.forEach(function(e){
      if(!!e){
        tempArr.push(e);
      }
    });
    return tempArr;
  }

  result(){
    return this._result;
  }

  getBrowser(){
    var ua = this.result().ua;
    var name = ua.family;
    var version = this.compact([ua.major, ua.minor, ua.patch]).join(".");
    return { name: name, version: version };
  }

  getOS(){
    var os = this.result().os;
    var name = os.family;
    var version = this.compact([os.major, os.minor, os.patch, os.patchMinor]).join(".");
    return { name: name, version: version };
  }

  getDevice(){
    var device = this.result().device;
    var model = device.family;
    var vendor = device.brand;
    return { model: model, vendor: vendor };
  }
}
